// @ts-nocheck
import * as selectors from './applyModeFromClipboardSelectors';

export { selectors };
